/**
 * Shared Mapbox camera defaults for owner-dashboard maps.
 * Baseline matches Local Intelligence; new maps should start from `DEFAULT_MAP_VIEW_CAMERA` and override only what differs.
 */

export type MapViewCameraConfig = {
    zoom: number;
    pitch: number;
    bearing: number;
    minZoom: number;
    maxZoom: number;
    minPitch: number;
    maxPitch: number;
};

export const DEFAULT_MAP_VIEW_CAMERA: MapViewCameraConfig = {
    zoom: 16.5,
    pitch: 45,
    bearing: 0,
    minZoom: 15,
    maxZoom: 20,
    minPitch: 15,
    maxPitch: 80,
};

/** Longitude shift (degrees west) for Local Intelligence only — makes room for the events side panel. */
export const LOCAL_INTELLIGENCE_LONGITUDE_OFFSET_EVENTS_PANE = 0.001;
